import React, { FormEvent, useState } from 'react';
import { login, logout, signup, type User } from '@netlify/identity';

type Props = { user: User | null; localMode: boolean; syncStatus: string; databaseMode: 'turso' | 'sqlite' | 'unavailable' };

export function CloudAccount({ user, localMode, syncStatus, databaseMode }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: { preventDefault: () => void }, action: 'login' | 'signup') {
    event.preventDefault(); setBusy(true); setMessage('');
    try {
      if (action === 'login') await login(email, password);
      else await signup(email, password);
      setMessage(action === 'signup' ? 'Account created. Check your email if confirmation is required.' : 'Signed in. Syncing your data…');
    } catch (error) { setMessage(error instanceof Error ? error.message : 'Could not sign in.'); }
    finally { setBusy(false); }
  }

  return <article className="panel backup-card cloud-card">
    <span className="backup-icon"><span aria-hidden="true">☁</span></span>
    <p className="eyebrow">CLOUD SYNC</p>
    <h2>{localMode ? 'Development data sync' : user ? 'Your account' : 'Sync between devices'}</h2>
    {localMode && <><p>{databaseMode === 'turso' ? 'Connected to your Turso development database.' : databaseMode === 'sqlite' ? <>Using local SQLite at <code>repday.local.db</code>. Turso credentials are optional for local development.</> : 'Waiting for the local data function to connect.'}</p><p className="import-status" role="status">{syncStatus}</p><p className="account-auth-note">Netlify Identity sign-in is unavailable in local development. Use your deployed site or a Deploy Preview to authenticate.</p></>}
    {user ? <><p>Signed in as <strong>{user.email}</strong>. Your Repday data is private to this account.</p>{!localMode && <p className="import-status" role="status">{syncStatus}</p>}<button className="secondary-button" onClick={() => logout()}>Sign out</button></> : <>
      {!localMode && <p>Create an account or sign in to sync your workout and weigh-in data across browsers.</p>}
      <form className="large-form single-column" onSubmit={event => submit(event, 'login')}>
        <div className="form-field"><label htmlFor="sync-email">Email</label><input id="sync-email" type="email" autoComplete="email" required value={email} onChange={event => setEmail(event.target.value)}/></div>
        <div className="form-field"><label htmlFor="sync-password">Password</label><input id="sync-password" type="password" autoComplete="current-password" required value={password} onChange={event => setPassword(event.target.value)}/></div>
        <button className="primary-button" disabled={busy || localMode} type="submit">Sign in</button>
        <button className="secondary-button" disabled={busy || localMode} type="button" onClick={event => submit(event, 'signup')}>Create account</button>
      </form>
      {message && <p className="import-status" role="status">{message}</p>}
    </>}
  </article>;
}
